.OnlyFansCreatorsSidebar {
  background-color: var(--primitives-colors-neutral-980);
  padding: 24px 16px;
  border-radius: 28px;
  border: 1px solid rgb(255, 255, 255, 0.2);
  width: 208px;
  margin: 2rem auto;
  position: relative;

  // transition: all 0.2s ease-in-out;
  min-height: 928px;

  &.OnlyFansCreatorsSidebarLoader {
    padding: 0;
  }

  .title {
    font: var(--font-body-md-semibold);
  }

  .list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 32px;
  }

  hr {
    width: 100%;
    height: 1px;
    background-color: var(--primitives-colors-neutral-0);
    opacity: 0.2;
    margin: -17px 0;
  }

  &.OnlyFansCreatorsSidebarStuck {
    padding: 16px;
    margin-bottom: 0;
    min-height: 0;

    .closeButton {
      position: absolute;
      top: 8px;
      right: 8px;
    }

    .title {
      font: var(--font-body-sm-semibold);
      margin: 0 0 8px;
      padding-right: 24px;
    }

    .list {
      gap: 20px;
    }

    hr {
      margin: -9.5px 0;
    }

    .AdCreator {
      .creatorImage {
        aspect-ratio: auto;
        height: clamp(72px, calc((var(--app-height) - 511px) / 3), 141px);
      }

      .creatorTitle {
        margin: 4px 0;
      }

      .creatorLink {
        --btn-height: var(--semantics-button-size-xs);
      }
    }
  }
}
